export default {
  isTest: false,
  uid: undefined,
  registrationData: undefined,
  isAgreed: undefined,
  isExperimentParticipant: undefined,
  FinalQAnswerd: false,
  loading: true,
  search: {},
  isAnswered: undefined,
  currentLat: undefined,
  currentLng: undefined,
  DepLatLng: undefined,
  DesLatLng: undefined,
  originalApiData: [],
  selectedSpot: undefined,
  selectedSpotRelieved: undefined,
  selectedSpotDocId: undefined,
  shoModalAll: false,
  showHelpModal: false,
  selectedSpotType: undefined,
  dropDestionaton: undefined,
  lastRoute: undefined,
  miniLoading: false,
  relievedLog: []
}



// WEBPACK FOOTER //
// ./src/store/state.js